// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "customer." + chunkId + "." + {"libs_customer_customer-inventory-v1_src_index_ts":"10aa29d6bf12ecca","libs_customer_customer-documents-v1_src_index_ts":"4551fe055dce872a","libs_customer_customer-approvals-v1_src_index_ts":"514772967da34446"}[chunkId] + ".js";
};